import AppProviderList from './AppProviderList';
import AppProviderShow from './AppProviderShow';

export default {
  list: AppProviderList,
  show: AppProviderShow,
};
